li.pure-g
  .pure-u-3-4
    .input-addon
      input(name="weight", type="number", step=1, min=model.product.weightEmpty, max=model.product.weightFull, placeholder=0, value=model.value || null).input-addon-field
      .input-addon-item g
  .pure-u-1-4.right
    a(href="#", role="button", data-hook="remove-weight")
      i.icon.ion-ios-minus-outline
